module.exports = "<router-outlet></router-outlet>\n<app-session-sharing [frameId]=\"sessionPropagationFrameId\"></app-session-sharing>"